import { Component, Input, OnInit } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-basic',
  templateUrl: './footer-basic.component.html',
  styleUrls: ['./footer-basic.component.scss']
})
export class FooterBasicComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  @Input() showClassVerify!: boolean;
  public environment = environment;

  constructor() { }

  ngOnInit(): void {
  }

}
